// extracted by mini-css-extract-plugin
export default {"root":"ResetPasswordForm_root__Y24Ja","form":"ResetPasswordForm_form__OrtQ1","button":"ResetPasswordForm_button__JT7Qy"};